import React from "react";
import PropTypes from "prop-types";
import styles from "./StockReportTable.module.css";
import { StockReportItem } from "../StockReportItem/StockReportItem";

const baseHeaders = [
  { label: "SKU:", align: "left", className: "headerSku" },
  { label: "Bin:", align: "left", className: "headerBin" },
  { label: "Title:", align: "left", className: "headerTitle" },
];

// Six blank week columns keep the layout when there's no data at all.
const blankDateHeaders = Array.from({ length: 6 }, () => ({
  primary: "",
  secondary: "",
}));

const metricHeaders = [
  { label: "6 W/Avg:", className: "metricAverage" },
  { label: "On Hand:", className: "metricOnHand" },
  { label: "W/Available:", className: "metricAvailable" },
];

export function StockReportTable({
  stockItemData = [],
  allRows = stockItemData,
}) {
  // Header date ranges follow the actual weekly buckets in the data. They come
  // from the whole report, so a search with no matches keeps the real weeks.
  const first = stockItemData[0] || allRows[0];
  const sample = first && first.salesByDate;
  const dateHeaders =
    sample && sample.length
      ? sample.map((entry) => ({
          primary: entry.date,
          secondary: entry.endDate || "",
        }))
      : blankDateHeaders;

  return (
    <div className={styles.table}>
      <div className={styles.tableContent}>
        <div className={styles.headerRow}>
          {baseHeaders.map(({ label, align, className }) => {
            const headerClasses = [
              styles.headerCell,
              align === "left" ? styles.left : "",
              className ? styles[className] : "",
            ]
              .filter(Boolean)
              .join(" ");

            return (
              <span key={label} className={headerClasses}>
                {label}
              </span>
            );
          })}
          {dateHeaders.map(({ primary, secondary }, i) => (
            <span
              key={`date-${i}-${primary}-${secondary}`}
              className={styles.dateHeader}
            >
              <span className={styles.dateHeaderPrimary}>{primary}</span>
              <span className={styles.dateHeaderSecondary}>{secondary}</span>
            </span>
          ))}
          {metricHeaders.map(({ label, className }) => {
            const metricClasses = [
              styles.headerCell,
              className ? styles[className] : "",
            ]
              .filter(Boolean)
              .join(" ");

            return (
              <span key={label} className={metricClasses}>
                {label}
              </span>
            );
          })}
        </div>

        <div className={styles.body}>
          {stockItemData.map((item, index) => (
            <StockReportItem
              key={item.id || `${item.sku}-${item.bin}-${index}`}
              {...item}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

StockReportTable.propTypes = {
  stockItemData: PropTypes.arrayOf(PropTypes.object).isRequired,
  allRows: PropTypes.arrayOf(PropTypes.object),
};
